import Jobs from './jobs.module';
import Orders from './orders.module';
import Organization from './organization.module';
import Promotions from './promotions.module';
import Vin from './vin.module';

const modules = {
  Jobs,
  Orders,
  Organization,
  Promotions,
  Vin,
};

const mutations = {
  setDealershipsByRole(state, dealershipArray) {
    state.dealershipsByRole = dealershipArray;
  },
};
const actions = {
  updateDealershipsByRole({ commit }, activeDealerships) {
    // only admins and reps can create transportation orders
    const filteredDealerships = activeDealerships.filter((dealership) => dealership.memberType === 'admin' || dealership.memberType === 'rep');
    commit('setDealershipsByRole', filteredDealerships);
  },
};

const state = {
  dealershipsByRole: [],
};
export default {
  namespaced: true,
  modules,
  mutations,
  actions,
  state,
};
